/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseCancelReservationResult } from '../models/ApiResponseCancelReservationResult';
import type { ApiResponseConfirmPaymentResult } from '../models/ApiResponseConfirmPaymentResult';
import type { ApiResponseCreateReservationResult } from '../models/ApiResponseCreateReservationResult';
import type { ApiResponseGetAllStationsResult } from '../models/ApiResponseGetAllStationsResult';
import type { ApiResponseGetAvailableDatesResult } from '../models/ApiResponseGetAvailableDatesResult';
import type { ApiResponseGetAvailableTimesResult } from '../models/ApiResponseGetAvailableTimesResult';
import type { ApiResponseGetDiscountInfoResult } from '../models/ApiResponseGetDiscountInfoResult';
import type { ApiResponseGetPaymentResult } from '../models/ApiResponseGetPaymentResult';
import type { ApiResponseGetReservationStatusResult } from '../models/ApiResponseGetReservationStatusResult';
import type { ApiResponseGetTodayFailCountResult } from '../models/ApiResponseGetTodayFailCountResult';
import type { ApiResponseGetVehicleResult } from '../models/ApiResponseGetVehicleResult';
import type { ApiResponseRegisterVehicleResult } from '../models/ApiResponseRegisterVehicleResult';
import type { ApiResponseReservePaymentResult } from '../models/ApiResponseReservePaymentResult';
import type { ApiResponseUnregisterVehicleResult } from '../models/ApiResponseUnregisterVehicleResult';
import type { ApiResponseUpdateReservationResult } from '../models/ApiResponseUpdateReservationResult';
import type { ApiResponseUpdateVehicleResult } from '../models/ApiResponseUpdateVehicleResult';
import type { CancelReservationCommand } from '../models/CancelReservationCommand';
import type { ConfirmPaymentCommand } from '../models/ConfirmPaymentCommand';
import type { CreateReservationCommand } from '../models/CreateReservationCommand';
import type { RegisterVehicleCommand } from '../models/RegisterVehicleCommand';
import type { ReservePaymentCommand } from '../models/ReservePaymentCommand';
import type { UnregisterVehicleCommand } from '../models/UnregisterVehicleCommand';
import type { UpdateReservationCommand } from '../models/UpdateReservationCommand';
import type { UpdateVehicleCommand } from '../models/UpdateVehicleCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicServiceInspectionService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 검사 차량 정보 변경
   * 검사 차량 정보를 변경합니다(관청등록일, 최근검사일).
   * @returns ApiResponseUpdateVehicleResult OK
   * @throws ApiError
   */
  public updateVehicle2({
    requestBody,
  }: {
    requestBody: UpdateVehicleCommand,
  }): CancelablePromise<ApiResponseUpdateVehicleResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/vehicle/update',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 검사 차량 삭제
   * 검사 차량을 삭제합니다. 확정예약건이 존재하는 경우 환불요청을 hmg-pay에 보냅니다.
   * @returns ApiResponseUnregisterVehicleResult OK
   * @throws ApiError
   */
  public unregisterVehicle({
    requestBody,
  }: {
    requestBody: UnregisterVehicleCommand,
  }): CancelablePromise<ApiResponseUnregisterVehicleResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/unregister',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 예약 선점 등록
   * 예약 선점을 등록합니다.
   * @returns ApiResponseCreateReservationResult OK
   * @throws ApiError
   */
  public createReservation({
    requestBody,
  }: {
    requestBody: CreateReservationCommand,
  }): CancelablePromise<ApiResponseCreateReservationResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/reservation',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 예약 정보 변경
   * 예약 정보(예약일시 한정)를 변경합니다.
   * @returns ApiResponseUpdateReservationResult OK
   * @throws ApiError
   */
  public updateReservation({
    requestBody,
  }: {
    requestBody: UpdateReservationCommand,
  }): CancelablePromise<ApiResponseUpdateReservationResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/reservation/update',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 결제 준비
   * 결제 준비 요청을 hmg-pay에 보냅니다.
   * @returns ApiResponseReservePaymentResult OK
   * @throws ApiError
   */
  public reservePayment({
    authorization,
    requestBody,
  }: {
    authorization?: string,
    requestBody: ReservePaymentCommand,
  }): CancelablePromise<ApiResponseReservePaymentResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/reservation/payment/reserve',
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 결제 승인 및 예약 확정
   * 결제 승인 요청을 hmg-pay에 보내고 예약을 확정합니다.
   * @returns ApiResponseConfirmPaymentResult OK
   * @throws ApiError
   */
  public confirmPayment({
    requestBody,
  }: {
    requestBody: ConfirmPaymentCommand,
  }): CancelablePromise<ApiResponseConfirmPaymentResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/reservation/payment/confirm',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 예약 취소
   * 예약/예약선점을 취소합니다. 확정예약건은 환불요청을 hmg-pay에 보냅니다.
   * @returns ApiResponseCancelReservationResult OK
   * @throws ApiError
   */
  public cancelPayment({
    requestBody,
  }: {
    requestBody: CancelReservationCommand,
  }): CancelablePromise<ApiResponseCancelReservationResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/reservation/cancel',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 검사 차량 등록
   * 검사 차량을 등록합니다.
   * @returns ApiResponseRegisterVehicleResult OK
   * @throws ApiError
   */
  public registerVehicle({
    requestBody,
  }: {
    requestBody: RegisterVehicleCommand,
  }): CancelablePromise<ApiResponseRegisterVehicleResult> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/inspection/register',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 검사 차량 정보 조회
   * 검사 차량 정보를 조회합니다(관청등록일, 최근검사일).
   * @returns ApiResponseGetVehicleResult OK
   * @throws ApiError
   */
  public getVehicle2({
    puid,
    licensePlateNumber,
  }: {
    puid: string,
    licensePlateNumber: string,
  }): CancelablePromise<ApiResponseGetVehicleResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/vehicle',
      query: {
        'puid': puid,
        'licensePlateNumber': licensePlateNumber,
      },
    });
  }
  /**
   * 전 차량 예약 상태 조회
   * 사용자가 등록한 모든 검사차량의 예약 상태를 조회합니다.
   * @returns ApiResponseGetReservationStatusResult OK
   * @throws ApiError
   */
  public getReservationStatus({
    puid,
  }: {
    puid: string,
  }): CancelablePromise<ApiResponseGetReservationStatusResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/status',
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * 검사 가능 시각 조회
   * 검사소, 차량번호, 일자에 대하여 검사가능시각을 조회합니다.
   * @returns ApiResponseGetAvailableTimesResult OK
   * @throws ApiError
   */
  public getAvailableTimes({
    stationCode,
    puid,
    licensePlateNumber,
    date,
  }: {
    stationCode: string,
    puid: string,
    licensePlateNumber: string,
    date: string,
  }): CancelablePromise<ApiResponseGetAvailableTimesResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/station/{stationCode}/available-times',
      path: {
        'stationCode': stationCode,
      },
      query: {
        'puid': puid,
        'licensePlateNumber': licensePlateNumber,
        'date': date,
      },
    });
  }
  /**
   * 검사 가능 일자 조회
   * 검사소, 차량번호에 대하여 검사가능일을 조회합니다.
   * @returns ApiResponseGetAvailableDatesResult OK
   * @throws ApiError
   */
  public getAvailableDates({
    stationCode,
    puid,
    licensePlateNumber,
  }: {
    stationCode: string,
    puid: string,
    licensePlateNumber: string,
  }): CancelablePromise<ApiResponseGetAvailableDatesResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/station/{stationCode}/available-dates',
      path: {
        'stationCode': stationCode,
      },
      query: {
        'puid': puid,
        'licensePlateNumber': licensePlateNumber,
      },
    });
  }
  /**
   * 전체 검사소 조회
   * 전체 검사소를 조회합니다. (기 방문 여부 포함)
   * @returns ApiResponseGetAllStationsResult OK
   * @throws ApiError
   */
  public getAllStations({
    puid,
    licensePlateNumber,
  }: {
    puid: string,
    licensePlateNumber: string,
  }): CancelablePromise<ApiResponseGetAllStationsResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/station/all',
      query: {
        'puid': puid,
        'licensePlateNumber': licensePlateNumber,
      },
    });
  }
  /**
   * 결제 정보 조회
   * 결제 정보를 조회합니다.
   * @returns ApiResponseGetPaymentResult OK
   * @throws ApiError
   */
  public getPayment({
    puid,
    merchantTransactionNo,
  }: {
    puid: string,
    merchantTransactionNo: string,
  }): CancelablePromise<ApiResponseGetPaymentResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/reservation/payment',
      query: {
        'puid': puid,
        'merchantTransactionNo': merchantTransactionNo,
      },
    });
  }
  /**
   * 당일 인증 실패 횟수 조회
   * 사용자의 당일 인증 실패 횟수를 조회합니다.
   * @returns ApiResponseGetTodayFailCountResult OK
   * @throws ApiError
   */
  public getTodayFailCount({
    puid,
  }: {
    puid: string,
  }): CancelablePromise<ApiResponseGetTodayFailCountResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/fail-count',
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * 감면 정보 조회
   * 사회적 약자 감면 정보를 조회합니다.
   * @returns ApiResponseGetDiscountInfoResult OK
   * @throws ApiError
   */
  public getDiscountInfo({
    puid,
    licensePlateNumber,
    socialWeakCode,
  }: {
    puid: string,
    licensePlateNumber: string,
    socialWeakCode: string,
  }): CancelablePromise<ApiResponseGetDiscountInfoResult> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/inspection/discount',
      query: {
        'puid': puid,
        'licensePlateNumber': licensePlateNumber,
        'socialWeakCode': socialWeakCode,
      },
    });
  }
}
